import * as React from "react";
import * as numeral from "numeral";
import { Button } from "react-bootstrap";
import * as prettyFileIcons from "pretty-file-icons";
import { parseFloatCommaDot, parseTagSanitizeAndWhitelist } from "../../../../helpers/Utils";

const importAll = (r) => {
	const modules = {};
	r.keys().forEach((item) => {
		modules[item.replace("./", "")] = r(item);
	});
	return modules;
};

// @ts-ignore
const images = importAll(require.context("pretty-file-icons/svg/", false, /\.(png|jpe?g|svg)$/));

export const actionCell = (cell, row) => (
	<>
		{!row.disableViewAndEditButton ? (// @ts-ignore
			<Button bsStyle="success" onClick={() => row.onDbClick(row)}>
				<span className={row.disabled ? "glyphicon glyphicon-eye-open" : "glyphicon glyphicon-pencil"} />
			</Button>
		) : null}

		{!row.disabled && (row?.extra?.del_row_enabled !== undefined ? row.extra.add_row_enabled : true) && (// @ts-ignore
			<Button onClick={() => row.onRowDelete(row)} bsStyle="danger">
				<span className="glyphicon glyphicon-remove" />
			</Button>
		)}
	</>
);

export function customCell(cell) {
	const type = this.type ? this.type.toUpperCase() : this.type;

	if (type === "NUMBER" || type === "FLOAT") {
		if (cell === "0") {
			return (
				<span className="number" title={cell}>
					-
				</span>
			);
		}
		if (this?.extra?.format === "currency") {
			if (cell?.length > 0) {
				return (
					<span className="number" title={cell}>
						{numeral(parseFloatCommaDot(cell)).format("0,0[.]00")}
					</span>
				);
			}
			return <span className="number" title={cell} />;
		}
		return (
			<span className="number" title={cell}>
				{cell}
			</span>
		);
	}

	if (type === "TEXTAREA") {
		return <span>{parseTagSanitizeAndWhitelist(cell, this?.extra?.allowed_tags)}</span>;
	}

	if (type === "CHECKBOXSET" || type === "RADIOBUTTON") {
		return (
			<span className="select-block" title={cell}>
				<ul>
					{this?.options?.map((option, idx) =>
						(Array.isArray(cell)
							? cell.indexOf(option.name) > -1
							: cell && option.name === cell?.toString()
						) ? <li key={idx}>{option.label}</li> : null
					)}
				</ul>
			</span>
		);
	}

	if (type === "SELECT") {
		const search = this.options?.find((i) => i?.key === +cell);
		// eslint-disable-next-line no-nested-ternary
		const value = this?.valueIs === "key" ? (search ? search.value : cell) : cell;
		const valueText = value && typeof value === "object" ? value.ru : value;

		return <span title={valueText}>{valueText}</span>;
	}

	if (type === "CONSTLINK") {
		return cell && <a href={cell.link_url}>{cell.link_title}</a>;
	}

	if (type === "CALENDAR") {
		if (this?.type.toUpperCase() === "RANGEDMULTICALENDAR") {
			return (
				<div>
					{cell?.length ? (
						cell.map((item) => (
							<div>
								{item?.beginDate}&nbsp;-&nbsp;{item?.finishDate}
							</div>
						))
					) : (
						<div>
							{cell?.beginDate}&nbsp;-&nbsp;{cell?.finishDate}
						</div>
					)}
				</div>
			);
		}
	}

	if (type === "CHECKBOX") {
		if (this.icons?.[`${!!cell}`]) {
			return <span className={`glyphicon ${this.icons[`${!!cell}`]}`}></span>;
		}
	}

	if (type === "DROPBOX") {
		if (this.urlOptions.length > 0) {
			return (
				<>
					{this.urlOptions.map((option) => (
						option.id === cell && <span key={option.id}>{option.name}</span>
					))}
				</>
			)
		} 
		if (this.options?.length > 0) {
			return (
				<>
					{this.options.map((option) => (
						option.key === cell && <span key={option.key}>{option.value?.ru}</span>
					))}
				</>
			)
		}
	}

	if (typeof cell === "boolean" && !!cell) {
		return <span title="+">+</span>;
	}

	return cell && typeof cell === "object" ? (
		<span title={cell}>{Object?.values(cell).join(" - ")}</span>
	) : (
		<span title={cell}>{cell !== undefined && !!cell && cell.toString().replace(/(<([^>]+)>)/gi, "")}</span>
	);
}

export const _fileCell = (cell) => {
	if (!Array.isArray(cell?.inputs)) {
		return null;
	}

	return (
		<>
			{cell?.inputs.map(file => {
				const fileIconPath = prettyFileIcons.getIcon(file.name);
				const fileIcon = images[`${fileIconPath}.svg`];

				return (
					<div>
						<a className="file-grid" href={file.url} download>
							<img className="fileicon fileicon--ingrid" src={fileIcon.default || fileIcon} alt={cell.value} />
							{file.name}
						</a>
					</div>
				)
			})}
		</>
	)
}
// TODO: !??!
export const fileCell = (cell) => {
	const parseCell = cell && typeof cell === "string" ? JSON.parse(cell) : cell;

	// TODO: SHADOW!!!! CELL
	const title =
		parseCell &&
		// eslint-disable-next-line no-shadow
		parseCell.map((cell) => {
			if (!cell?.value) {
				return;
			}
			const extension =
				(cell.value.toLowerCase().endsWith(".docx") && " .doc") ||
				(!cell.value.toLowerCase().endsWith(".docx") && cell.value);
			const fileIconPath = prettyFileIcons.getIcon(extension);
			const fileIcon = images[`${fileIconPath}.svg`];
			// TODO:!!! return
			// eslint-disable-next-line consistent-return
			return `<a class="file-grid" href="${cell.url}" download title="${
				cell.value
			}"><img class="fileicon fileicon--ingrid" src=${fileIcon.default || fileIcon} alt=${cell.value} /> ${
				cell.value
			}</a>`;
		});
	return <span title={cell} dangerouslySetInnerHTML={{ __html: title && title.join("<br />") }} />;
};

export const emptyCell = () => <div />;
